import { useState } from "react";
import { Button, message, Upload } from "antd";
import { UploadChangeParam, UploadFile } from "antd/lib/upload";
import { saveAs } from 'file-saver';

const Jinye = () => {
  const [file, setFile] = useState<UploadFile<any> | null>(null);

  const [loading, setLoading] = useState(false);

  const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
    setFile(info.file);
  };

  const readFile = async (file: any) => {
    return new Promise<string>((res, rej) => {
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = () => {
        res(reader.result as string);
      };
      reader.onerror = () => {
        rej('文件解析失败');
      };
    });
  };

  const matchQuestions = (str: string) => {
    const m = str.match(/(?<=p_questions.push\().*(?=\)[\n\r]+)/g);
    if (!m) return matchExamQuestions(str);
    return Array.from(m).map(item => JSON.parse(item)).map(item => {
      const answer = typeof item.answer === 'string' ? JSON.parse(item.answer) : item.answer;
      const option = typeof item.option === 'string' ? JSON.parse(item.option) : item.option;
      return {
        ...item,
        answer,
        option,
      };
    });
  };

  const matchExamQuestions = (str: string) => {
    const fragment = new DocumentFragment();
    const div = document.createElement('div');
    div.innerHTML = str;
    fragment.append(div);
    const questions = fragment.querySelectorAll('.questions');
    return Array.from(questions).map(item => {
      const questionContent = item.querySelector<HTMLDivElement>('.question-content');
      const q: any = { };
      if (questionContent) {
        q.id = questionContent.dataset.id;
        q.type = questionContent.dataset.type;
        q.audio_address = '';
        const answer = questionContent.dataset.answer || questionContent.attributes.getNamedItem('date-answer')?.value;
        q.answer = answer ? JSON.parse(window.atob(answer)) : '';
      }
      const examQuestion = item.querySelector<HTMLDivElement>('.exam-question');
      if (examQuestion) {
        q.description = examQuestion.innerHTML;
      }
      const answers = item.querySelectorAll<HTMLDivElement>('.answers>div');
      q.option = Array.from(answers).map(answer => {
        const input = answer.querySelector('input');
        const words = answer.querySelector('span.words');
        return { key: input?.dataset.name, value: words?.innerHTML };
      }).reduce((data, it) => {
        if (it.key) data[it.key] = it.value;
        return data;
      }, {} as Record<string, any>);

      return q;
    });
  };

  const createTable = (questions: any[]) => {
    const table = document.createElement('table');
    const thead = document.createElement('thead');
    const tbody = document.createElement('tbody');
    table.appendChild(thead);
    table.appendChild(tbody);
    const headers = ['id', 'type', 'description', 'option', 'audio_address', 'answer'];
    const headTr = document.createElement('tr');
    thead.appendChild(headTr);
    headers.forEach(item => {
      const td = document.createElement('td');
      td.innerHTML = item;
      headTr.appendChild(td);
    });
    questions.forEach(question => {
      const tr = document.createElement('tr');
      tbody.appendChild(tr);
      headers.forEach(item => {
        const td = document.createElement('td');
        tr.appendChild(td);
        if (item === 'answer') {
          if (question.answer && question.answer.answer) {
            td.innerHTML = question.answer.answer.toString();
          }
        } else if (item === 'option') {
          if (question.option) {
            Object.keys(question.option).forEach(key => {
              const div = document.createElement('div');
              td.appendChild(div);
              div.innerHTML = `${key}: ${question.option[key]}`;
            });
          }
        } else {
          td.innerHTML = question[item];
        }
      });
    });
    return table;
  };

  const handleClick = async () => {
    try {
      setLoading(true);
      if (!file) throw new Error('请先上传网页文件');
      const html = await readFile(file);
      const questions = matchQuestions(html);
      if (!questions || questions.length === 0) throw new Error('未找到题目');
      const table = createTable(questions);
      const blob = new Blob([table.outerHTML], { type: "text/html;charset=utf-8" });
      saveAs(blob, `${Date.now()}.xls`);
    } catch (e: any) {
      message.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Upload.Dragger
        maxCount={1}
        onChange={handleChange}
        beforeUpload={() => false}
      >
        上传网页文件
      </Upload.Dragger>
      <Button
        block
        style={{ marginTop: 60 }}
        loading={loading}
        onClick={handleClick}
      >
        导出excel
      </Button>
    </div>
  );
};

export default Jinye;
